import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import Button from '@mui/material/Button';

import Loading from 'components/UI/Loading/Loading';
import DialogMessage from 'components/UI/DialogMessage/DialogMessage';

import classes from './MemoriesCollage.module.css';

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`
  };
}

const INITIAL_BATCH_SIZE = 30;
const BATCH_INCREMENT = 30;

const MemoriesCollage = props => {
  const [showDialog, setShowDialog] = useState(false);
  const [visibleCount, setVisibleCount] = useState(
    INITIAL_BATCH_SIZE
  );

  const openModalHandler = () => {
    setShowDialog(true);
  };

  const closeDialogHandler = () => {
    setShowDialog(false);
  };

  useEffect(() => {
    setVisibleCount(INITIAL_BATCH_SIZE);
  }, [props.lstMemory]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 600
      ) {
        setVisibleCount(prev => {
          if (props.lstMemory && prev < props.lstMemory.length) {
            return Math.min(
              prev + BATCH_INCREMENT,
              props.lstMemory.length
            );
          }
          return prev;
        });
      }
    };

    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [props.lstMemory]);

  const visibleMemories =
    Array.isArray(props.lstMemory) && props.lstMemory.length > 0
      ? props.lstMemory.slice(0, visibleCount)
      : [];

  return (
    <>
      <ul className={classes.collageContainer}>
        {props.lstMemory != null ? (
          props.lstMemory.length > 0 &&
          visibleMemories.map(memory => (
            <li
              className={classes.imageContainer}
              key={memory.memoryId}
              cols={memory.cols || 1}
              rows={memory.rows || 1}
            >
              <Button
                className={classes.linkMemory}
                component={Link}
                to={`/tribut/${props.tributId}/memories/${memory.memoryId}`}
                onClick={e => {
                  if (
                    memory.mediaType === 'mp4' &&
                    !memory.thumbnail
                  ) {
                    e.preventDefault();
                    openModalHandler();
                    return;
                  }
                  if (typeof props.seeMemory === 'function') {
                    const fn = props.seeMemory(memory.memoryId);
                    if (typeof fn === 'function') {
                      fn(e);
                    }
                  }
                }}
              >
                <img
                  className={classes.itemCollage}
                  {...srcset(
                    memory.thumbnail,
                    121,
                    memory.rows,
                    memory.cols
                  )}
                  alt={memory.mediaType || 'memory'}
                  loading="lazy"
                />
                <aside className={classes.typeFile}>
                  {memory.mediaType === 'mp4' ||
                    memory.mediaType === 'quicktime' ||
                    (memory.mediaType === 'HLS' && (
                      <MovieOutlinedIcon
                        className={classes.infoIcon}
                      />
                    ))}
                </aside>
                <aside className={classes.moreInfoContainer}>
                  <p className={classes.info}>
                    <ThumbUpOutlinedIcon
                      className={classes.infoIcon}
                    />{' '}
                    {memory.countLikes}
                  </p>
                  <p className={classes.info}>
                    <ForumOutlinedIcon
                      className={classes.infoIcon}
                    />{' '}
                    {memory.comments.length}
                  </p>
                </aside>
              </Button>
            </li>
          ))
        ) : (
          <Loading />
        )}
      </ul>
      <DialogMessage
        closeDialog={closeDialogHandler}
        video
        title={'Video en proceso'}
        open={showDialog}
        message={
          'La publicación del video está en proceso.  No cambies la pantalla y espera un momento por favor.'
        }
      />
    </>
  );
};

MemoriesCollage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  tributId: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  lstMemory: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  // eslint-disable-next-line react/require-default-props
  seeMemory: PropTypes.func
};

export default MemoriesCollage;
